<i ui-icon uiType="ui-1_circle-delete"></i>
<h3>{{ error.title | localize }}</h3>
<p *ngIf="error.message && (!errorOptions || !errorOptions.hideMessage)">{{ error.message | localize }}</p>
<p *ngIf="error.body && (!errorOptions || !errorOptions.hideBody)">{{ error.body }}</p>
<p *ngIf="error.transactionId">{{ "transaction_id" | localize }}: {{ error.transactionId }}</p>
<p *ngIf="error.showIntercomLink">
  {{ "problem_persist_pls" | localize }} <button (click)="showIntercom()" ui-button uiType="link">{{ "contact_our_team" | localize }}</button>
</p>
